import { render, staticRenderFns } from "./MilestoneAwardSetupTab.vue?vue&type=template&id=2d32be5a&scoped=true&"
import script from "./MilestoneAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./MilestoneAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MilestoneAwardSetupTab.vue?vue&type=style&index=0&id=2d32be5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d32be5a",
  null
  
)

export default component.exports